import { extendTailwindMerge } from "tailwind-merge";
import { allColorVariants, radiusNames, shadowNames, typographyStyleNames } from "./tailwind-merge-tokens.generated.js";
const twMergeConfig = {
    override: {
        classGroups: {
            'text-decoration': [
                'underline',
                'overline'
            ]
        }
    },
    extend: {
        classGroups: {
            'text-decoration-strike': [
                'line-through'
            ],
            'text-decoration-none': [
                'no-underline'
            ],
            'text-color': [
                {
                    text: allColorVariants
                }
            ],
            'bg-color': [
                {
                    bg: allColorVariants
                }
            ],
            'border-color': [
                {
                    border: allColorVariants
                }
            ],
            'border-x-color': [
                {
                    'border-x': allColorVariants
                }
            ],
            'border-y-color': [
                {
                    'border-y': allColorVariants
                }
            ],
            'border-s-color': [
                {
                    'border-s': allColorVariants
                }
            ],
            'border-e-color': [
                {
                    'border-e': allColorVariants
                }
            ],
            'border-t-color': [
                {
                    'border-t': allColorVariants
                }
            ],
            'border-r-color': [
                {
                    'border-r': allColorVariants
                }
            ],
            'border-b-color': [
                {
                    'border-b': allColorVariants
                }
            ],
            'border-l-color': [
                {
                    'border-l': allColorVariants
                }
            ],
            'divide-color': [
                {
                    divide: allColorVariants
                }
            ],
            'outline-color': [
                {
                    outline: allColorVariants
                }
            ],
            'ring-color': [
                {
                    ring: allColorVariants
                }
            ],
            'ring-offset-color': [
                {
                    'ring-offset': allColorVariants
                }
            ],
            'accent-color': [
                {
                    accent: allColorVariants
                }
            ],
            'caret-color': [
                {
                    caret: allColorVariants
                }
            ],
            fill: [
                {
                    fill: allColorVariants
                }
            ],
            stroke: [
                {
                    stroke: allColorVariants
                }
            ],
            'font-size': [
                {
                    text: typographyStyleNames
                }
            ],
            rounded: [
                {
                    rounded: radiusNames
                }
            ],
            'rounded-s': [
                {
                    'rounded-s': radiusNames
                }
            ],
            'rounded-e': [
                {
                    'rounded-e': radiusNames
                }
            ],
            'rounded-t': [
                {
                    'rounded-t': radiusNames
                }
            ],
            'rounded-r': [
                {
                    'rounded-r': radiusNames
                }
            ],
            'rounded-b': [
                {
                    'rounded-b': radiusNames
                }
            ],
            'rounded-l': [
                {
                    'rounded-l': radiusNames
                }
            ],
            'rounded-ss': [
                {
                    'rounded-ss': radiusNames
                }
            ],
            'rounded-se': [
                {
                    'rounded-se': radiusNames
                }
            ],
            'rounded-ee': [
                {
                    'rounded-ee': radiusNames
                }
            ],
            'rounded-es': [
                {
                    'rounded-es': radiusNames
                }
            ],
            'rounded-tl': [
                {
                    'rounded-tl': radiusNames
                }
            ],
            'rounded-tr': [
                {
                    'rounded-tr': radiusNames
                }
            ],
            'rounded-br': [
                {
                    'rounded-br': radiusNames
                }
            ],
            'rounded-bl': [
                {
                    'rounded-bl': radiusNames
                }
            ],
            shadow: [
                {
                    shadow: shadowNames
                }
            ]
        },
        conflictingClassGroups: {
            'text-decoration-none': [
                'text-decoration',
                'text-decoration-strike'
            ],
            'text-decoration': [
                'text-decoration-none'
            ],
            'text-decoration-strike': [
                'text-decoration-none'
            ]
        }
    }
};
const twMerge = extendTailwindMerge(twMergeConfig);
export { twMerge, twMergeConfig };
